/* WOLF BROS – size engine shared by the collection size filter.
   Works out the customer's size from the height + weight they entered once (saved in this browser),
   using the same charts and maths as the size guide on the product page (assets/wb-fit.js). */
(function () {
  'use strict';
  if (window.WBSize) return;

  /* same charts as the "WB product extras" section (size guide) */
  var CHARTS = {
    tops: { head: ['size', 'height (cm)', 'weight (kg)', 'chest (cm)'], rows: [
      ['XS', '155-165', '45-55', '86-91'], ['S', '160-170', '55-65', '91-96'], ['M', '168-176', '65-75', '96-101'], ['L', '173-181', '75-85', '101-106'],
      ['XL', '178-186', '85-95', '106-112'], ['2XL', '181-190', '95-105', '112-118'], ['3XL', '184-195', '105-118', '118-124'], ['4XL', '186-198', '118-130', '124-130']] },
    bottoms: { head: ['size', 'waist (cm)', 'weight (kg)', 'height (cm)'], rows: [
      ['XS', '68-72', '45-55', '155-165'], ['S', '72-76', '55-65', '160-170'], ['M', '76-82', '65-75', '168-176'], ['L', '82-88', '75-85', '173-181'],
      ['XL', '88-94', '85-95', '178-186'], ['2XL', '94-100', '95-105', '181-190'], ['3XL', '100-108', '105-118', '184-195']] },
    jeans: { head: ['size', 'waist (cm)', 'weight (kg)', 'height (cm)'], rows: [
      ['W28', '71', '50-58', '160-170'], ['W29', '74', '56-63', '162-172'], ['W30', '76', '61-68', '165-175'], ['W31', '79', '66-72', '168-177'],
      ['W32', '81', '70-76', '170-180'], ['W33', '84', '74-80', '172-182'], ['W34', '86', '78-85', '174-185'], ['W36', '91', '84-93', '176-188'],
      ['W38', '97', '92-102', '178-190'], ['W40', '102', '100-112', '180-195']] }
  };

  var KEY = 'wbFit';
  function get() {
    try { var s = JSON.parse(localStorage.getItem(KEY) || 'null'); if (s && +s.h && +s.w) return { h: +s.h, w: +s.w, fit: +s.fit || 0 }; } catch (e) {}
    return null;
  }
  function set(h, w, fit) {
    try { localStorage.setItem(KEY, JSON.stringify({ h: +h, w: +w, fit: +fit || 0 })); } catch (e) {}
    try { window.dispatchEvent(new CustomEvent('wb:size-profile')); } catch (e) {}
  }
  function valid(h, w) { return h >= 130 && h <= 220 && w >= 35 && w <= 200; }

  var norm = function (v) { return String(v).toUpperCase().replace(/\s+/g, '').replace(/^XXXL$/, '3XL').replace(/^XXL$/, '2XL').replace(/^XXXXL$/, '4XL'); };
  var rangeOf = function (s) { var m = String(s).match(/(\d+(?:\.\d+)?)\s*[-–]\s*(\d+(?:\.\d+)?)/); if (m) return [+m[1], +m[2]]; var n = String(s).match(/\d+(?:\.\d+)?/); return n ? [+n[0], +n[0]] : null; };
  var bodyFrom = function (h, w) { return { chest: 58 + 0.5 * w + 0.1 * (h - 175), waist: 0.6 * w + 0.15 * h + 8 }; };
  var fitName = function (kind, ease) {
    if (kind === 'tops') {
      if (ease < 2) return { key: 'tight', name: 'Too tight' };
      if (ease < 9.5) return { key: 'fitted', name: 'Fitted' };
      if (ease < 17) return { key: 'regular', name: 'Regular' };
      if (ease < 26) return { key: 'relaxed', name: 'Relaxed' };
      return { key: 'oversized', name: 'Oversized' };
    }
    if (ease < -1.5) return { key: 'tight', name: 'Too tight' };
    if (ease < 1.8) return { key: 'fitted', name: 'Snug' };
    if (ease < 5) return { key: 'regular', name: 'Regular' };
    if (ease < 9) return { key: 'relaxed', name: 'Relaxed' };
    return { key: 'big', name: 'Too big' };
  };
  var targetFor = function (kind, fit) { return kind === 'tops' ? (fit < 0 ? 6 : fit > 0 ? 21 : 13) : (fit < 0 ? 0.5 : fit > 0 ? 6.5 : 3); };

  /* every chart size with how it fits this body */
  function evaluate(kind, p) {
    var ch = CHARTS[kind]; if (!ch || !p) return [];
    var tops = kind === 'tops';
    var col = function (word) { for (var i = 0; i < ch.head.length; i++) if (ch.head[i].indexOf(word) > -1) return i; return -1; };
    var ci = tops ? col('chest') : col('waist'), hi = col('height');
    var body = bodyFrom(p.h, p.w), bm = tops ? body.chest : body.waist;
    return ch.rows.map(function (row, i) {
      var rg = rangeOf(row[ci]), garment;
      if (tops) garment = rg[1] + 6; else if (kind === 'jeans') garment = rg[0] + 1.5; else garment = (rg[0] + rg[1]) / 2 + 2.5;
      var ease = garment - bm, fit = fitName(kind, ease);
      var hr = hi > -1 ? rangeOf(row[hi]) : null;
      if (hr && p.h > hr[1] + (tops ? 9 : 7) && fit.key !== 'tight') fit = { key: 'short', name: 'Too short' };
      return { i: i, size: row[0], key: norm(row[0]), ease: ease, fit: fit };
    });
  }
  var okFit = function (s) { return s.fit.key !== 'tight' && s.fit.key !== 'big' && s.fit.key !== 'short'; };
  function ideal(kind, p) {
    var list = evaluate(kind, p), t = targetFor(kind, p ? p.fit : 0), best = null;
    list.forEach(function (s) { if (!okFit(s)) return; var d = Math.abs(s.ease - t); if (!best || d < best.d) best = { s: s, d: d }; });
    if (!best && list.length) best = { s: list.slice().sort(function (a, b) { return Math.abs(a.ease - t) - Math.abs(b.ease - t); })[0] };
    return best ? best.s : null;
  }
  /* jeans leg length that suits the height */
  var legFor = function (h) { return h < 170 ? 30 : h <= 182 ? 32 : 34; };

  /* words for a size next to the ideal one */
  function feel(s, dir, steps) {
    if (dir < 0) return (s.fit.key === 'tight' || steps > 1) ? 'tight' : s.fit.key === 'short' ? 'a bit short' : 'a bit tight';
    return (s.fit.key === 'big' || s.fit.key === 'oversized' || steps > 1) ? 'loose' : 'a bit loose';
  }

  /* availableKeys: chart keys that can be bought (e.g. ['S','L'] or ['W30','W34']) */
  function advise(kind, p, availableKeys) {
    var list = evaluate(kind, p), id = ideal(kind, p);
    if (!id) return null;
    var have = {}; (availableKeys || []).forEach(function (k) { have[norm(k)] = 1; });
    var out = { ideal: id, available: !!have[id.key], smaller: null, larger: null };
    if (out.available) return out;
    for (var a = id.i - 1; a >= 0 && a >= id.i - 2; a--) if (have[list[a].key]) { out.smaller = { size: list[a].size, feel: feel(list[a], -1, id.i - a) }; break; }
    for (var b = id.i + 1; b < list.length && b <= id.i + 2; b++) if (have[list[b].key]) { out.larger = { size: list[b].size, feel: feel(list[b], 1, b - id.i) }; break; }
    return out;
  }

  window.WBSize = { CHARTS: CHARTS, get: get, set: set, valid: valid, norm: norm, evaluate: evaluate, ideal: ideal, advise: advise, legFor: legFor, feel: feel, fitName: fitName, targetFor: targetFor };
})();
